export const boxShadows = {
  questionLayout: "0px -6px 12px 0px rgba(0, 0, 0, 0.25)",
  xl: "rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
  "2xl": "0px 8px 16px rgba(0, 0, 0, 0.25)",
};
